import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { clearToken, getToken, validateStoredToken } from '../auth';

const ProtectedRoute = ({ children }) => {
  const [phase, setPhase] = useState(() => (getToken() ? 'checking' : 'unauthed'));

  useEffect(() => {
    if (phase !== 'checking') {
      return;
    }
    let cancelled = false;
    (async () => {
      const ok = await validateStoredToken();
      if (cancelled) {
        return;
      }
      if (ok) {
        setPhase('authed');
      } else {
        clearToken();
        setPhase('unauthed');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [phase]);

  if (phase === 'unauthed') {
    return <Navigate to="/login" replace />;
  }

  if (phase === 'checking') {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return children;
};

export default ProtectedRoute;
